<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.46875 3.9999C2.46875 3.66853 2.73406 3.3999 3.06134 3.3999H12.9379C13.2652 3.3999 13.5305 3.66853 13.5305 3.9999C13.5305 4.33127 13.2652 4.5999 12.9379 4.5999H3.06134C2.73406 4.5999 2.46875 4.33127 2.46875 3.9999Z"
      fill="#2E3138"
    />
    <path
      d="M2.46875 7.9999C2.46875 7.66853 2.73406 7.3999 3.06134 7.3999H12.9379C13.2652 7.3999 13.5305 7.66853 13.5305 7.9999C13.5305 8.33127 13.2652 8.5999 12.9379 8.5999H3.06134C2.73406 8.5999 2.46875 8.33127 2.46875 7.9999Z"
      fill="#2E3138"
    />
    <path
      d="M3.06134 11.3999C2.73406 11.3999 2.46875 11.6685 2.46875 11.9999C2.46875 12.3313 2.73406 12.5999 3.06134 12.5999H12.9379C13.2652 12.5999 13.5305 12.3313 13.5305 11.9999C13.5305 11.6685 13.2652 11.3999 12.9379 11.3999H3.06134Z"
      fill="#2E3138"
    />
  </svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-bars'
});
</script>
